import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {useState} from "react";
import TopNavbar from "./components/TopNavbar";
import Users from "./components/users/Users";
import UsernamePasswordLogin from "./components/authentication/UsernamePasswordLogin";
import Voices from "./components/voices/Voices";
import SttServiceProviders from "./components/sttServiceProviders/SttServiceProviders";
import SpeechModels from "./components/speechModels/SpeechModels";
import Languages from "./components/languages/Languages";
import TTSServiceProviders from "./components/ttsServiceProviders/TTSServiceProviders";
import LanguageLocales from "./components/languageLocales/LanguageLocales";
import Roles from "./components/roles/Roles";
import Projects from "./components/project/Projects";
import BackgroundFiles from "./components/backgroundFiles/BackgroundFiles";
import {ToastContainer} from 'react-toastify'

export default function App() {
    const [loggedInUser, setLoggedInUser] = useState({});

    const onSuccessfulLogin = (user) => {
        setLoggedInUser(user)
        console.log("Login Successful");
    }

    const onSuccessfulLogout = () => {
        setLoggedInUser({});
        console.log("Logout Successful");
        window.location.href = '/';
    }

    const isUserLoggedIn = () => {
        return loggedInUser && Object.keys(loggedInUser).length > 0;
    }

    return (
        <div id="App">
            {!isUserLoggedIn() &&
                <UsernamePasswordLogin
                    onSuccessfulLogin={(loggedInUser) => onSuccessfulLogin(loggedInUser)}/>
            }

            {isUserLoggedIn() &&
                <>
                    <Router>
                        <TopNavbar onSuccessfulLogout={onSuccessfulLogout} loggedInUser={loggedInUser}/>
                        <Routes>
                            <Route exact path="/" element={<Home/>}/>
                            <Route path="/users" element={<Users loggedInUser={loggedInUser}></Users>}/>
                            <Route path="/roles" element={<Roles loggedInUser={loggedInUser}></Roles>}/>/>
                            <Route path="/projects" element={<Projects loggedInUser={loggedInUser}> </Projects>}/>

                            <Route path="/permissions" element={<Permissions/>}/>
                            <Route path="/languages" element={<Languages/>}/>
                            <Route path="/languageLocales" element={<LanguageLocales/>}/>
                            <Route path="/backgroundFiles" element={<BackgroundFiles/>}/>
                            <Route path="/sttServiceProviders" element={<SttServiceProviders/>}/>
                            <Route path="/speechModels" element={<SpeechModels/>}/>
                            <Route path="/ttsServiceProviders" element={<TTSServiceProviders/>}/>
                            <Route path="/voices" element={<Voices />}/>
                        </Routes>
                    </Router>
                </>
            }
            <ToastContainer />
        </div>
    );
}

function Home() {
    return (
        <div className="mainBody">Home</div>
    )
}

function Permissions() {
    return (
        <div className="mainBody">
            <h1>Permissions</h1>
        </div>
    )
}
